var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var User_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { Utils } from '@symon-ai/wisepipe-common';
import './authToken'; // force import for JsonSchemaV2
import { userSchemaValidation } from '../validations.generated';
// TODO: WP-6128: remove UserPlan after 2.19.0 release
export var UserPlan;
(function (UserPlan) {
    UserPlan["Social"] = "Social";
    UserPlan["Enterprise"] = "Enterprise";
    UserPlan["Integration"] = "Integration";
})(UserPlan || (UserPlan = {}));
// Cognito user attributes
export var CognitoUserAttribute;
(function (CognitoUserAttribute) {
    CognitoUserAttribute["Email"] = "email";
    CognitoUserAttribute["Name"] = "name";
    CognitoUserAttribute["Sub"] = "sub";
    CognitoUserAttribute["PreferredUsername"] = "preferred_username";
    CognitoUserAttribute["CreatedAt"] = "custom:createdAt";
    CognitoUserAttribute["Source"] = "custom:source";
    CognitoUserAttribute["CognitoUserStatus"] = "cognito:user_status";
    CognitoUserAttribute["Identities"] = "identities";
    CognitoUserAttribute["MarketingAgreed"] = "custom:marketingAgreed";
    CognitoUserAttribute["EmailVerified"] = "email_verified";
    CognitoUserAttribute["MarketingCampaign"] = "custom:marketingCampaign";
    CognitoUserAttribute["UiDomain"] = "custom:uiDomain"; // used by sign up by invite emails
})(CognitoUserAttribute || (CognitoUserAttribute = {}));
export var UserAdhocClaims;
(function (UserAdhocClaims) {
    UserAdhocClaims["FeatureFlags"] = "feature_flags";
})(UserAdhocClaims || (UserAdhocClaims = {}));
export const userSchema = {
    $id: 'urn:wisepipe-user:User',
    type: 'object',
    properties: {
        ID: { type: 'string', minLength: 1, maxLength: 128 },
        auth: { $ref: 'urn:wisepipe-user:AuthToken' },
        loginType: { type: 'string' },
        name: { type: 'string' },
        email: { type: 'string' }
    },
    required: ['ID', 'auth']
};
// Arbitrary wildcard ID to represent all users
// Used as both ROLE_ID for all users as well as USER_ID
// - used in authorize:v3.sql
export const USER_ID_ALL = '00000000-0000-0000-0000-000000000000';
let User = User_1 = class User {
    // Returns the ID as a Buffer
    get bufferID() {
        return Utils.uuidStringToBuffer(this.ID);
    }
    constructor(id, auth, loginType, name, email) {
        this.ID = id;
        this.auth = auth;
        if (loginType)
            this.loginType = loginType;
        if (name)
            this.name = name;
        if (email)
            this.email = email;
        JSON.validate(this, User_1);
    }
    static bufferID(orgID) {
        return Utils.uuidStringToBuffer(orgID);
    }
    static userID(buffer) {
        return Utils.uuidUintArrayToString(buffer);
    }
    static get Header() {
        return 'wisepipe-user';
    }
    static get NameHeader() {
        return 'wisepipe-user-name';
    }
    static get EmailHeader() {
        return 'wisepipe-user-email';
    }
    static getSource(clientID, isSocial) {
        if (clientID)
            return `Integration - ${clientID}`;
        const plan = isSocial ? 'Social' : 'Enterprise';
        return `Web - ${plan}`;
    }
};
User = User_1 = __decorate([
    JsonSchemaV2(userSchema, userSchemaValidation)
], User);
export { User };
//# sourceMappingURL=user.js.map